var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceRequestsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.580078,
    width: 44,
    height: 44,
    rx: 10,
    fill: "#171717",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 16.3301C13 14.8113 14.2312 13.5801 15.75 13.5801H28.25C29.7688 13.5801 31 14.8113 31 16.3301V28.8301C31 30.3489 29.7688 31.5801 28.25 31.5801H15.75C14.2312 31.5801 13 30.3489 13 28.8301V16.3301ZM21.1396 18.7823C21.3881 18.451 21.321 17.9808 20.9896 17.7323C20.6582 17.4838 20.1881 17.551 19.9396 17.8823L18.4937 19.8102L17.959 19.4538C17.6143 19.224 17.1487 19.3172 16.9189 19.6618C16.6892 20.0065 16.7823 20.4721 17.1269 20.7019L18.2519 21.4519C18.5831 21.6727 19.0291 21.5963 19.268 21.2778L21.1396 18.7823ZM23.808 18.8301C23.3937 18.8301 23.058 19.1659 23.058 19.5801C23.058 19.9943 23.3937 20.3301 23.808 20.3301H26.308C26.7222 20.3301 27.058 19.9943 27.058 19.5801C27.058 19.1659 26.7222 18.8301 26.308 18.8301H23.808ZM21.1396 24.7835C21.3881 24.4521 21.321 23.982 20.9896 23.7334C20.6582 23.4849 20.1881 23.5521 19.9396 23.8835L18.4937 25.8114L17.959 25.4549C17.6143 25.2252 17.1487 25.3183 16.9189 25.6629C16.6892 26.0076 16.7823 26.4732 17.1269 26.703L18.2519 27.453C18.5831 27.6738 19.0291 27.5974 19.268 27.279L21.1396 24.7835ZM23.75 24.8301C23.3358 24.8301 23 25.1659 23 25.5801C23 25.9943 23.3358 26.3301 23.75 26.3301H26.25C26.6642 26.3301 27 25.9943 27 25.5801C27 25.1659 26.6642 24.8301 26.25 24.8301H23.75Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRequestsActive);
export default __webpack_public_path__ + "static/media/service-requests-active.8da7910f688fd974475f0130737a0cb0.svg";
export { ForwardRef as ReactComponent };